// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../addSeconds/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var addSeconds = convertToFP(fn, 2);
export default addSeconds;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/addSeconds/index.js
// module id = 817
// module chunks = 0